import { isDemoAccountBlocked } from './demoAccountInterceptor';

/**
 * Traduce el rechazo del backend a algo que pueda leer una persona.
 *
 * `AllExceptionFilter` responde en inglés y con vocabulario técnico; ese texto
 * llegaba tal cual al modal. Sólo se traduce lo que el usuario puede provocar
 * y entender: el resto cae en un mensaje genérico, sin enseñar el error crudo.
 *
 * `null` para la cuenta demo de los revisores: su bloqueo ya lo cuenta el aviso único
 * (`DemoAccountBlockedNotice`) y el diálogo no debe pintar otro error debajo.
 */
export function translateWithdrawalError(
	error: unknown,
	translate: (k: string) => string
): string | null {
	if (isDemoAccountBlocked(error)) return null;

	const message = error instanceof Error ? error.message : '';

	if (/already an in-progress withdrawal request/i.test(message)) {
		return translate('rescue.solicitarDialog.errorAlreadyOpen');
	}

	// Restricción legal (RD 304/2004 art. 9): enfermedad grave y desempleo de
	// larga duración sólo se cobran como capital único.
	if (/can only be paid as a lump sum/i.test(message)) {
		return translate('rescue.solicitarDialog.errorLumpSumOnly');
	}

	// Rechazos permanentes: decir "inténtalo en unos minutos" sería un consejo
	// falso, porque reintentar nunca va a funcionar.
	if (/requires an amount greater than 0|requires a monthly amount/i.test(message)) {
		return translate('rescue.solicitarDialog.errorAmountRequired');
	}

	if (/not found|only request withdrawals on your own/i.test(message)) {
		return translate('rescue.solicitarDialog.errorNoPlan');
	}

	return translate('rescue.solicitarDialog.errorGeneric');
}
